import Config from './config';

class Common {
  static getAPIHost() {

    if (Config.api.port)
      return window.location.protocol + "//" + Config.api.host + ':' + Config.api.port + '/';
    else {
      var protocol = window.location.protocol;
      if (protocol === 'file:') {
        protocol = 'https:';
      }
      return "https://" + Config.api.host + '/';
    }
  }

  static isMobile() {
    //return window.orientation > -1;
    var width = window.innerWidth;
    if (width < 800)
      return true;
    else
      return false;
  }

  static getTitleList(forceLang) {
    var titleItem = {
      'TH': {
        'ajahn': 'พระอาจารย์',
        'history': 'ประวัติการฟัง',
        'like': 'ธรรมะที่ฉันชอบ',
        'feedback': 'ฝากข้อคิดเห็น',
        'feedbackDesc': 'ท่านใดมีข้อคิดเห็นอะไรบอกมาได้เลยนะครับ',
        'feedbackHint': '',
        'feedbackValidate': 'ต้องการข้อมูลในช่องนี้ครับ',
        'selAjahn': 'พระอาจารย์',
        'modeTitleW': ['ธรรมะรายวัน', 'ธรรมะยอดนิยม', 'รายการ'],
        'modeTitleM': ['รายวัน','ยอดนิยม','รายการ'],
        'cancel':'ยกเลิก',
        'download': 'ดาวน์โหลด',
        'by': 'โดย',
        'modeSendButton': 'ส่งข้อความ',
        'loading': 'กำลังโหลด',
        'thankTitle': 'ขอขอบคุณ',
        'thankList': [
          {title:'วัดญาณเวศกวัน', link:'http://www.watnyanaves.net/th/home'},
          {title:'ฟังธรรม.com', link:'http://www.fungdham.com'},
          {title:'ธรรมะไทย', link:'http://www.dhammathai.org'},
          {title:'ธรรมะพีเดีย', link:'http://www.thammapedia.com'},
          {title:'เว็บไซต์พระอาจารย์ชยสาโร', link:'https://www.jayasaro.panyaprateep.org/'}
        ],
        'copyLinkText': 'copy link เรียบร้อย อย่าลืมนำไป paste นะครับ',
        'relationTopic': 'แนะนำ'
      },
      'EN' : {
        'ajahn': 'Ajahn',
        'history': 'History',
        'like': 'My Like',
        'feedback': 'Feedback',
        'selAjahn': 'Ajahn',
        'feedbackDesc': 'We would be happy to receive your feedback',
        'feedbackHint': '',
        'feedbackValidate': 'The field is required',
        'modeTitleW': ['Dhamma Today', 'Dhamma Popular', 'Menu'],
        'modeTitleM': ['Today','Popular','Menu'],
        'cancel': 'Cancel',
        'download': 'Download',
        'by': 'by',
        'modeSendButton': 'Send',
        'loading': 'loading',
        'thankTitle': 'Thank you',
        'thankList': [
          {title:'Ajahn Jayasaro Website', link:'https://www.jayasaro.panyaprateep.org/'},
          {title:'Amaravati Buddhist Monastery', link:'https://www.amaravati.org/'}
        ],
        'copyLinkText': 'Already to copy the link',
        'relationTopic': 'Suggestion'
      }
    }
    if (forceLang) {
      return titleItem[forceLang];
    }
    else {
      return titleItem[localStorage.getItem("lang")];
    }
  }

  static getTempToken() {
    return new Promise((resolve, reject) => {
      var tempToken = localStorage.getItem("tempToken");
      if (tempToken) {
        resolve(tempToken);
      }
      else {
        fetch(Common.getAPIHost(), { 
          method: 'POST',
          body: JSON.stringify({
            funct: 'getTempToken'
          })
        })
          .then((resp) => resp.json()) // Transform the data into json
          .then(function(data) {
            localStorage.setItem("tempToken", data.tempToken);
            resolve(data.tempToken);
          });
      }
    });
  }

  static getDataFromService(data) {
    var url = Common.getAPIHost();
    return new Promise((resolve, reject) => {
      fetch(url,
        { 
          method: 'POST',
          body: JSON.stringify(data)
        })
        .then((resp) => resp.json()) // Transform the data into json
        .then(resolve);
    })
  }

  static initLang(parent) {
    return new Promise((resolve, reject) => {
      if (localStorage.getItem("lang")) {
        resolve();
      }
      else {
        parent.loading.showLoading();
        fetch("https://freegeoip.net/json/")
          .then((resp) => resp.json(), () =>{
            localStorage.setItem("lang", "TH");
            resolve();
          }) // Transform the data into json
          .then((data) => {
            if (!data || data.country_code === 'TH') {
              localStorage.setItem("lang", "TH");
            }
            else {
              localStorage.setItem("lang", "EN");
            }
            resolve();
          }, () => {
            localStorage.setItem("lang", "TH");
            resolve();
          })
      }
    });
  }

  static numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  static sendListenOverN(mp3Id, n) {
    var sendObj = {funct: 'tracking'};
    sendObj.mp3Id = mp3Id;
    Common.getTempToken().then((token) => {
      sendObj.token = token;
      sendObj.site = window.localStorage.getItem('lang');
      sendObj.trackTime = n
      fetch(Common.getAPIHost(),{
        method: 'POST',
        body: JSON.stringify(sendObj)
      })
        .then((resp) => resp.json()) // Transform the data into json
        .then(function(data) {
          // put something
        });
    });
  }

  static sendPlayingStat(mp3Id, searchText, noteIdx) {
    var sendObj = {funct: 'playingDhamma'};
    sendObj.mp3Id = mp3Id;
    if (searchText && searchText.trim() !== '') {
      sendObj.searchText = searchText;
    }
    if (noteIdx) {
      sendObj.noteIdx = noteIdx;
    }

    Common.getTempToken().then((token) => {
      sendObj.token = token;
      sendObj.site = window.localStorage.getItem('lang');
      fetch(Common.getAPIHost(), { 
        method: 'POST',
        body: JSON.stringify(sendObj)
      })
        .then((resp) => resp.json()) // Transform the data into json
        .then(function(data) {
          // put something
        });
    });
  }

  static sendPayloadMessage(payload) {
    return new Promise((resolve, reject) => {
      Common.getTempToken().then((token) => {
        payload.token = token;
        payload.site = window.localStorage.getItem('lang');
        if (payload.topic === 'like') {
          payload.funct = 'setLike';
        } else if (payload.topic === 'playList') {
          payload.funct = 'setPlayList';
        }
        fetch(Common.getAPIHost(), { 
          method: 'POST',
          body: JSON.stringify(payload)
        })
          .then((resp) => resp.json()) // Transform the data into json
          .then((data) => {
            resolve();
          }, () => {
            reject();
          });
      });
    });
  }

  static getMediaRelation(mediaId) {
    return new Promise((resolve, reject) => {
      var site = window.localStorage.getItem('lang');
      Common.getDataFromService({
        "q": mediaId,
        "site": site
      }).then((data) => {
          resolve(data);
        }, () => {
          reject();
        })
    });
  }

  static convertSecondToHour(totalSeconds) {
    totalSeconds = Math.floor(totalSeconds);
    var minutes = Math.floor(totalSeconds / 60);
    var seconds = totalSeconds % 60;
    minutes = ('0' + minutes).slice(-2);
    seconds = ('0' + seconds).slice(-2);
    return minutes + ':' + seconds;
  }
}

export default Common;



// WEBPACK FOOTER //
// ./src/Common.js